module.exports = __webpack_public_path__ + "static/media/ejkcard.2b7dc4a2.png";